import { render, staticRenderFns } from "./SyncMessages.vue?vue&type=template&id=c2d7ff58&scoped=true"
import script from "./SyncMessages.vue?vue&type=script&lang=js"
export * from "./SyncMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d7ff58",
  null
  
)

export default component.exports